@if (!isLoading() && hasTips()) {
  <p-button
    (click)="reductionTipsService.openDialog()"
    [label]=""
    size="small"
    [pTooltip]="unmetCommitmentsTooltip"
    [tooltipDisabled]="!hasUnmetCommitments()"
    tooltipPosition="top"
  >
    <!-- Bouton vert dans tous les cas : seuls l'icone et la pastille alertent -->
    <lucide-icon
      [name]="hasUnmetCommitments() ? 'triangle-alert' : 'lightbulb'"
      size="14px"
    />
    <span class="text-paragraph-s-reg">{{
      "reductionTips.openButton" | transloco
    }}</span>
    <!-- Combien d'engagements ce voyage rate, lisible sans ouvrir la modale -->
    @if (hasUnmetCommitments()) {
      <span
        class="inline-flex h-4 min-w-4 items-center justify-center rounded-full bg-orange-500 px-1 text-paragraph-xs-reg font-medium"
      >
        {{ unmetCommitments().length }}
      </span>
    }
  </p-button>

  <ng-template #unmetCommitmentsTooltip>
    <div class="flex flex-col gap-1 text-paragraph-xs-reg">
      <span class="font-medium">{{
        "reductionTips.commitments.unmetTitle" | transloco
      }}</span>
      <ul class="flex list-none flex-col gap-0.5">
        @for (commitment of unmetCommitments(); track commitment.action) {
          <li>
            &bull;
            {{
              "objectives.reductionActions." + commitment.action + ".title"
                | transloco
            }}
          </li>
        }
      </ul>
    </div>
  </ng-template>

  <p-dialog
    [(visible)]="reductionTipsService.dialogVisible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '90%', maxWidth: '1440px' }"
  >
    <ng-template pTemplate="header">
      <div class="flex flex-1 items-center gap-4">
        <div class="flex items-center gap-3">
          <div class="rounded-full bg-primary-200 p-2 text-primary-500">
            <lucide-icon name="lightbulb" [size]="18" />
          </div>
          <h2 class="text-heading-4 font-semibold text-primary-900">
            {{ "reductionTips.title" | transloco }}
          </h2>
        </div>

        <!-- Meme bascule que la page : elle pilote les deux -->
        <p-selectButton
          [options]="viewModeOptions"
          [(ngModel)]="impactService.viewMode"
          optionLabel="label"
          optionValue="value"
          [allowEmpty]="false"
          size="small"
          styleClass="p-selectbutton-sm"
        />
      </div>
    </ng-template>

    <!-- Hauteur bornee ici : seule la liste de conseils scrolle, la modale non -->
    <div class="flex h-[70vh] flex-col">
      <!-- Ce que fait cette modale -->
      <p class="mb-4 shrink-0 text-paragraph-s-reg text-greyscale-600">
        {{ "reductionTips.intro" | transloco }}
      </p>

      <div class="flex min-h-0 flex-1 flex-row items-start gap-4">
        <!-- Liste des conseils, scrollable independamment -->
        <section
          class="flex min-w-0 flex-1 flex-col gap-3 self-stretch overflow-y-auto px-2"
        >
          @for (objective of objectiveTips(); track $index) {
            <app-reduction-objective-card [objective]="objective" />
          }

          @if (tipGroups().length > 0) {
            <ul class="flex flex-col gap-2">
              @for (group of tipGroups(); track group.type) {
                <li>
                  <app-reduction-tip-group [group]="group" />
                </li>
              }
            </ul>
          }

          <!-- Engagements deja respectes par ce voyage -->
          @if (respectedCommitments().length > 0) {
            <section
              class="rounded-lg border border-validation-200 bg-validation-50 p-3"
            >
              <div class="mb-2 flex items-center gap-3">
                <div
                  class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-validation-200"
                >
                  <lucide-icon
                    name="circle-check"
                    [size]="16"
                    class="text-validation-600"
                  />
                </div>
                <h4 class="text-paragraph-s-reg font-medium text-primary-900">
                  {{ "reductionTips.commitments.title" | transloco }}
                </h4>
              </div>
              <ul class="space-y-1">
                @for (
                  commitment of respectedCommitments();
                  track commitment.action
                ) {
                  <li class="flex items-center gap-2">
                    <lucide-icon
                      name="check"
                      [size]="14"
                      class="shrink-0 text-validation-600"
                    />
                    <span
                      class="min-w-0 flex-1 truncate text-paragraph-s-reg text-greyscale-700"
                    >
                      {{
                        "objectives.reductionActions." +
                          commitment.action +
                          ".title" | transloco
                      }}
                    </span>
                    <span
                      class="shrink-0 text-paragraph-xs-reg font-medium text-validation-600"
                    >
                      {{ "reductionTips.commitments.respected" | transloco }}
                    </span>
                  </li>
                }
              </ul>
            </section>
          }
        </section>

        <!-- Simulation : donut recalcule selon les conseils coches -->
        <app-reduction-tips-summary class="shrink-0 self-start px-4" />
      </div>
    </div>
  </p-dialog>
}
